import script from "./DocumentDiv.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentDiv.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentDiv.vue?vue&type=style&index=0&id=605021ae&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-605021ae"]])

export default __exports__